import React, { FC } from 'react'
import { StyledProfileMenu } from './style';
import Navlink from '@/Components/atoms/Navlink';
import CommonSvg, { svgNames } from '@/Components/atoms/CommonSvg';
import { useTranslation } from 'next-i18next';
import { AiOutlineFullscreenExit, AiOutlineLogout } from 'react-icons/ai';
import { useContextSelector } from 'use-context-selector';
import { AuthContext } from '@/Context/Auth';
import { useUserData } from '@/Hooks/useUserData';
import Link from 'next/link';
import { useConfirm } from "@/Hooks/useConfirm";


// TODO fix: error cause when import ProfilePageModules from outside
// import { ProfilePageModules } from '../..';
// TODO fix: duplicate
export enum ProfilePageModules {
  default = 'default',
  wallet = 'wallet',
  my_posts = 'my_posts',
  archived_chats = 'archived_chats',
  user_settings = 'user_settings',
  notifications = 'notifications',
  privacy = 'privacy',
  service = 'service',
  language = 'language',
}

interface IProfilePageLink {
  path: string;
  name_key: string;
  icon: svgNames;
  moduleName: ProfilePageModules;
}
const ProfilePageLinks: IProfilePageLink[] = [
  {
    path: '/profile/wallet',
    name_key: 'profile.wallet',
    icon: svgNames.Wallet,
    moduleName: ProfilePageModules.wallet
  },
  {
    path: '/profile/my_posts',
    name_key: 'profile.my_posts',
    icon: svgNames.My_posts,
    moduleName: ProfilePageModules.my_posts
  },
  {
    path: '/profile/archived_chats',
    name_key: 'profile.archived_chats',
    icon: svgNames.Chats,
    moduleName: ProfilePageModules.archived_chats
  },
  {
    path: '/profile/user_settings',
    name_key: 'profile.user_settings',
    icon: svgNames.User_settings,
    moduleName: ProfilePageModules.user_settings
  },
  // {
  //   path: '/profile/notifications',
  //   name_key: 'profile.notifications',
  //   icon: svgNames.Notifications,
  //   moduleName: ProfilePageModules.notifications
  // },
  {
    path: '/profile/language',
    name_key: 'profile.language',
    icon: svgNames.Language,
    moduleName: ProfilePageModules.language
  },
  {
    path: '/profile/privacy',
    name_key: 'profile.privacy',
    icon: svgNames.Document,
    moduleName: ProfilePageModules.privacy
  },
  {
    path: '/profile/service',
    name_key: 'profile.service',
    icon: svgNames.Document,
    moduleName: ProfilePageModules.service
  },
]

interface IProfilePageMenuProps {
  onSelect: (name: ProfilePageModules) => void;
  activeModule: ProfilePageModules;
};

const ProfilePageMenu: FC<IProfilePageMenuProps> = ({ onSelect, activeModule }) => {
  const userData = useUserData();
  const logout = useContextSelector(AuthContext, v => v.actions.logout);
  const confirm = useConfirm();

  const onLogout = () => {
    confirm({ description: t('common:logout_info'), confirmationText: t("common:yes"), cancellationText: t("common:no") })
      .then(() => {
        logout();
      }, () => {})
  };

  const { t } = useTranslation(['profile', 'common']);
  return (
    <StyledProfileMenu>
      <h2 className='title'>{t('profile.title')}</h2>
      
      <div className='paper'>
        <div className='user-data'>
          <strong>{ userData?.firstname + ' ' + userData?.lastname }</strong>
          <span>ID: { userData?.phone?.slice(1) }</span>
        </div>
        <div className='profile-menu'>
          <ul className='profile-menu__list'>
            {
              ProfilePageLinks.map((link, index) => {
                return (
                  <li className='profile-menu__item' key={index}>
                    <Link shallow={true} className={'profile-menu__link ' + (link.moduleName === activeModule ? 'active-navlink' : '') } href={link.path} onClick={() => onSelect(link.moduleName)}>
                      <CommonSvg name={link.icon} />
                      {t(link.name_key)}
                    </Link>
                  </li>
                )
              })
            }
            <li className='profile-menu__item' onClick={onLogout}>
              <div className='profile-menu__link'>
                <AiOutlineLogout />
                { t('common:logout') }
              </div>
            </li>
          </ul>
        </div>
      </div>
    </StyledProfileMenu>
  )
}

export default ProfilePageMenu;

